<template>
	<div class="seller-record">
		<div class="btnbox">
			<el-button size="small" @click="goList">云仓列表</el-button>
			<el-button size="small" @click="goStock">在仓库存</el-button>
			<el-button size="small" @click="goSettle">结算中心</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item>
						<el-select v-model="formfilter.warehouse_id" placeholder="全部云仓" filterable clearable>
							<el-option label="全部云仓" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in warehouses" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="formfilter.state" placeholder="全部状态" clearable>
							<el-option label="全部状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v, k) in stateList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="id" label="批次" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column prop="warehouse_name" label="云仓" align="center" header-align="center" min-width="110px"></el-table-column>
					<el-table-column prop="state_str" label="状态" align="center" header-align="center" width="90px">
						<template slot-scope="scope">
							<span :class="'state-' + scope.row.state">{{ scope.row.state_str }}</span>
						</template>
					</el-table-column>
					<el-table-column label="明细摘要" align="center" header-align="center" min-width="220px">
						<template slot-scope="scope">
							<div class="summary-text">{{ formatSummary(scope.row) }}</div>
							<div class="summary-styles" v-if="summaryStyles(scope.row)">{{ summaryStyles(scope.row) }}</div>
							<div v-if="rejectBadgeText(scope.row)" :class="'reject-badge reject-badge-' + rejectState(scope.row)">{{ rejectBadgeText(scope.row) }}</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="申请时间" align="center" header-align="center" width="160px"></el-table-column>
					<el-table-column label="审核/物流" align="center" header-align="center" min-width="160px">
						<template slot-scope="scope">
							<div v-if="scope.row.state == 2">拒绝：{{ scope.row.audit_remark || '-' }}</div>
							<div v-if="scope.row.shipping_name">{{ scope.row.shipping_name }} {{ scope.row.shipping_tracking_no }}</div>
							<div v-if="scope.row.shipping_time_str">{{ scope.row.shipping_time_str }}</div>
							<div v-if="scope.row.audit_time_str && scope.row.state != 2">审核：{{ scope.row.audit_time_str }}</div>
							<div v-if="scope.row.reject_shipping_name">退回：{{ scope.row.reject_shipping_name }} {{ scope.row.reject_tracking_no }}</div>
							<div v-if="scope.row.reject_ship_time_str">寄出：{{ scope.row.reject_ship_time_str }}</div>
							<div v-if="scope.row.reject_confirm_time_str">确认收货：{{ scope.row.reject_confirm_time_str }}</div>
						</template>
					</el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="150px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openDetail(scope.row)">详情</span>
								<span v-if="scope.row.state == 1" @click="openShip(scope.row)">填写发货</span>
								<span v-else-if="scope.row.state == 0">等待审核</span>
								<span v-else-if="scope.row.state == 3">等待验收</span>
								<span v-if="rejectState(scope.row) == 1">等待仓东寄回</span>
								<span v-if="rejectState(scope.row) == 2" @click="onRejectConfirm(scope.row)">确认收货</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog :title="'入仓详情 · 批次 ' + (currentDetail.id || '')" :visible.sync="detailShow" width="860px" :before-close="closeDetail">
			<div class="detail-box" v-if="detailShow">
				<div class="detail-meta">
					<div><span>云仓</span>{{ currentDetail.warehouse_name || '-' }}</div>
					<div><span>状态</span><em :class="'state-' + currentDetail.state">{{ currentDetail.state_str || '-' }}</em></div>
					<div><span>申请时间</span>{{ currentDetail.create_time_str || '-' }}</div>
					<div><span>摘要</span>{{ formatSummary(currentDetail) }}</div>
				</div>
				<div class="detail-extra" v-if="currentDetail.state == 2">拒绝：{{ currentDetail.audit_remark || '-' }}</div>
				<div class="detail-extra" v-if="currentDetail.shipping_name">
					物流：{{ currentDetail.shipping_name }} {{ currentDetail.shipping_tracking_no }}
					<template v-if="currentDetail.shipping_time_str"> · {{ currentDetail.shipping_time_str }}</template>
				</div>
				<div class="detail-extra" v-if="currentDetail.audit_time_str && currentDetail.state != 2">
					审核：{{ currentDetail.audit_time_str }}
				</div>
				<div class="detail-extra" v-if="currentDetail.state == 4 && currentDetail.inspect_time_str">
					验收：{{ currentDetail.inspect_time_str }}
					<template v-if="currentDetail.inspect_remark"> · {{ currentDetail.inspect_remark }}</template>
				</div>
				<div class="detail-extra" v-if="rejectBadgeText(currentDetail)" :class="'reject-badge-' + rejectState(currentDetail)">
					{{ rejectBadgeText(currentDetail) }}
					<template v-if="rejectState(currentDetail) == 1"> · 等待仓东寄回</template>
				</div>
				<div class="detail-extra" v-if="currentDetail.reject_shipping_name">
					退回物流：{{ currentDetail.reject_shipping_name }} {{ currentDetail.reject_tracking_no }}
					<template v-if="currentDetail.reject_ship_time_str"> · {{ currentDetail.reject_ship_time_str }}</template>
				</div>
				<div class="detail-extra" v-if="currentDetail.reject_confirm_time_str">
					确认收货：{{ currentDetail.reject_confirm_time_str }}
				</div>
				<el-table :data="detailGroups" border size="mini" style="width: 100%">
					<el-table-column prop="style_number" label="款号" width="140" align="center" header-align="center"></el-table-column>
					<el-table-column label="供货折扣" width="90" align="center" header-align="center">
						<template slot-scope="scope">{{ formatEntryDiscount(scope.row.discount) }}折</template>
					</el-table-column>
					<el-table-column label="供货价" width="90" align="center" header-align="center">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.unit_cost) }}</template>
					</el-table-column>
					<el-table-column label="尺码明细" min-width="280" align="left" header-align="center">
						<template slot-scope="scope">
							<div class="size-chip" v-for="item in scope.row.sizes" :key="item.id">
								<strong>{{ item.size }}</strong>
								申请{{ item.apply_quantity }}
								<template v-if="currentDetail.state == 4">
									· 实收{{ item.received_quantity }} · 不合格{{ item.rejected_quantity }} · 入仓{{ item.net_quantity }}
								</template>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button v-if="currentDetail.state == 1" type="primary" @click="openShipFromDetail">填写发货</el-button>
				<el-button v-if="rejectState(currentDetail) == 2" type="primary" @click="onRejectConfirm(currentDetail)">确认收货</el-button>
				<el-button @click="closeDetail">关闭</el-button>
			</div>
		</el-dialog>

		<el-dialog title="填写发货" :visible.sync="shipShow" width="480px" :before-close="closeShip">
			<div class="forms" v-if="shipShow">
				<el-form ref="shipForm" :model="shipForm" :rules="shipRules" label-width="100px">
					<el-form-item label="快递公司" prop="shipping_name">
						<el-input v-model="shipForm.shipping_name" placeholder="请输入快递公司"></el-input>
					</el-form-item>
					<el-form-item label="物流单号" prop="shipping_tracking_no">
						<el-input v-model="shipForm.shipping_tracking_no" placeholder="请输入物流单号"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeShip">取消</el-button>
				<el-button type="primary" :loading="shipping" @click="onShip">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg, formatEntryDiscount } from './money.js'

	export default {
		name: 'SellerWarehouseRecord',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					warehouse_id: '',
					state: ''
				},
				warehouses: [],
				stateList: [
					{ id: 0, name: '待审核' },
					{ id: 1, name: '通过' },
					{ id: 2, name: '拒绝' },
					{ id: 3, name: '已发货' },
					{ id: 4, name: '已验收' }
				],
				detailShow: false,
				currentDetail: {},
				queryOpened: false,
				shipShow: false,
				shipping: false,
				currentBatch: {},
				shipForm: {
					shipping_name: '',
					shipping_tracking_no: ''
				},
				shipRules: {
					shipping_name: [{ required: true, message: '请输入快递公司', trigger: 'blur' }],
					shipping_tracking_no: [{ required: true, message: '请输入物流单号', trigger: 'blur' }]
				}
			}
		},
		computed: {
			detailGroups() {
				return this.groupItems(this.currentDetail.items)
			}
		},
		mounted() {
			this.loadWarehouses()
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
				}
			})
			this.resizeObserver.observe(this.$refs.filter)
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			formatEntryDiscount: formatEntryDiscount,
			rejectState(row) {
				return Number((row && row.reject_state) || 0)
			},
			rejectedTotal(row) {
				return Number((row && row.rejected_total) || 0)
			},
			rejectBadgeText(row) {
				var st = this.rejectState(row)
				var n = this.rejectedTotal(row)
				if (st == 1) {
					return '不合格 ' + n + ' 件待退回'
				}
				if (st == 2) {
					return (row && row.reject_state_str) || '退回中'
				}
				if (st == 3) {
					return (row && row.reject_state_str) || '已退回'
				}
				return ''
			},
			batchSummary(row) {
				var items = (row && row.items) || []
				var styles = {}
				var qty = 0
				var amount = 0
				items.forEach(function(item) {
					if (item.style_number) {
						styles[item.style_number] = true
					}
					qty += Number(item.apply_quantity || 0)
					amount += Number(item.unit_cost || 0) * Number(item.apply_quantity || 0)
				})
				return {
					productCount: Object.keys(styles).length,
					skuCount: items.length,
					qty: qty,
					amount: amount
				}
			},
			formatSummary(row) {
				var s = this.batchSummary(row)
				var text = s.productCount + '款 / ' + s.skuCount + '尺码 / 共' + s.qty + '件 / ¥' + this.fenToYuan(s.amount)
				if (row && row.state == 4) {
					var net = ((row.items || [])).reduce(function(sum, item) {
						return sum + Number(item.net_quantity || 0)
					}, 0)
					text += ' / 入仓' + net + '件'
				}
				return text
			},
			summaryStyles(row) {
				var names = []
				var seen = {}
				;((row && row.items) || []).forEach(function(item) {
					if (item.style_number && !seen[item.style_number]) {
						seen[item.style_number] = true
						names.push(item.style_number)
					}
				})
				if (!names.length) {
					return ''
				}
				if (names.length <= 2) {
					return names.join('、')
				}
				return names.slice(0, 2).join('、') + ' 等' + names.length + '款'
			},
			groupItems(items) {
				var map = {}
				var order = []
				;(items || []).forEach(function(item) {
					var key = item.style_number || item.product_id || item.id
					if (!map[key]) {
						map[key] = {
							style_number: item.style_number,
							discount: item.discount,
							unit_cost: item.unit_cost,
							composite_discount: item.composite_discount,
							composite_cost: item.composite_cost,
							sizes: []
						}
						order.push(map[key])
					}
					map[key].sizes.push(item)
				})
				return order
			},
			openDetail(row) {
				this.currentDetail = row || {}
				this.detailShow = true
			},
			closeDetail() {
				this.detailShow = false
				this.currentDetail = {}
			},
			openShipFromDetail() {
				var row = this.currentDetail
				this.closeDetail()
				this.openShip(row)
			},
			tryOpenQueryBatch() {
				var id = this.$route.query.batch_id
				if (!id || this.queryOpened) {
					return
				}
				var row = this.list.filter(function(item) {
					return String(item.id) === String(id)
				})[0]
				if (row) {
					this.queryOpened = true
					this.openDetail(row)
				}
			},
			goList() {
				this.$router.push('/seller/warehouse/index')
			},
			goStock() {
				this.$router.push('/seller/warehouse/stock')
			},
			goSettle() {
				this.$router.push('/seller/warehouse/settle')
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter = { warehouse_id: '', state: '' }
				this.page = 1
				this.onlist()
			},
			loadWarehouses() {
				this.$axios.get('api/cloud_warehouse/warehouse_list', {
					params: { page: 1, limit: 100 }
				}).then(res => {
					if (res.data.code === 0) {
						this.warehouses = (res.data.data && res.data.data.list) || []
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			onlist() {
				var params = {
					page: this.page,
					limit: this.pageSize,
					role: 'seller'
				}
				if (this.formfilter.warehouse_id !== '' && this.formfilter.warehouse_id !== null) {
					params.warehouse_id = this.formfilter.warehouse_id
				}
				if (this.formfilter.state !== '' && this.formfilter.state !== null) {
					params.state = this.formfilter.state
				}
				this.$axios.get('api/cloud_warehouse/entry_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
						this.tryOpenQueryBatch()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			openShip(row) {
				this.currentBatch = row
				this.shipForm = {
					shipping_name: '',
					shipping_tracking_no: ''
				}
				this.shipShow = true
				this.$nextTick(() => {
					if (this.$refs.shipForm) {
						this.$refs.shipForm.clearValidate()
					}
				})
			},
			closeShip() {
				this.shipShow = false
				this.currentBatch = {}
			},
			onRejectConfirm(row) {
				var batch = row || {}
				if (!batch.id) {
					return
				}
				this.$confirm('确认已收到该批次退回的不合格品？', '确认收货', {
					type: 'warning'
				}).then(() => {
					this.$axios.post('api/cloud_warehouse/entry_reject_confirm', {
						batch_id: batch.id
					}).then(res => {
						if (res.data.code === 0) {
							this.$message.success('已确认收货')
							this.closeDetail()
							this.onlist()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						console.log(err)
					})
				}).catch(() => {})
			},
			onShip() {
				this.$refs.shipForm.validate((valid) => {
					if (!valid) {
						return
					}
					this.shipping = true
					this.$axios.post('api/cloud_warehouse/entry_ship', {
						batch_id: this.currentBatch.id,
						shipping_name: this.shipForm.shipping_name,
						shipping_tracking_no: this.shipForm.shipping_tracking_no
					}).then(res => {
						this.shipping = false
						if (res.data.code === 0) {
							this.$message.success('发货信息已提交')
							this.closeShip()
							this.onlist()
						} else {
							this.$message.error(apiMsg(res))
						}
					}).catch(err => {
						this.shipping = false
						console.log(err)
					})
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-record {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.summary-text {
		line-height: 20px;
	}

	.summary-styles {
		font-size: 12px;
		color: #909399;
		line-height: 18px;
	}

	.reject-badge {
		font-size: 12px;
		line-height: 18px;
		margin-top: 2px;
	}

	.reject-badge-1 { color: #E6A23C; }
	.reject-badge-2 { color: #409EFF; }
	.reject-badge-3 { color: #909399; }

	.detail-meta {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 12px;
		div {
			width: 50%;
			line-height: 26px;
			span {
				display: inline-block;
				width: 70px;
				color: #909399;
			}
			em {
				font-style: normal;
			}
		}
	}

	.detail-extra {
		margin-bottom: 8px;
		color: #606266;
		font-size: 13px;
	}

	.size-chip {
		display: inline-block;
		margin: 2px 12px 2px 0;
		line-height: 22px;
		strong {
			margin-right: 4px;
		}
	}

	.state-0 { color: #E6A23C; }
	.state-1 { color: #409EFF; }
	.state-2 { color: #F56C6C; }
	.state-3 { color: #409EFF; }
	.state-4 { color: #67C23A; }
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/record.vue